<div class="data-display-cell"
     [class]="displayFormat"
     [class.layout-inline]="displayLayout === 'inline'"
     [class.layout-stacked]="displayLayout === 'stacked'"
     [class.align-left]="textAlign === 'left'"
     [class.align-center]="textAlign === 'center'"
     [class.align-right]="textAlign === 'right'">
  <div class="data-display-container">
    <!-- Label (if configured) -->
    <div class="data-label" *ngIf="displayLabel" [ngStyle]="labelStyle">
      {{ displayLabel }}
    </div>
    
    <!-- Data Value -->
    <div class="data-value" [class.loading]="isLoading">
      <mat-spinner diameter="20" *ngIf="isLoading" class="loading-spinner"></mat-spinner>
      <span *ngIf="!isLoading"
            class="value-text"
            [class.no-data]="displayValue.startsWith('[')"
            [ngStyle]="valueStyle">
        {{ displayValue }}
      </span>
    </div>
  </div>
</div>